// frontend/src/components/member-dashboard/components/ActivityFeed.js
import React, { useState, useEffect } from "react";
import { activityAPI } from "../../../services/api";
import { FaSpinner, FaReceipt, FaCalendarAlt } from "react-icons/fa";
import "./ActivityFeed.css";

const ActivityFeed = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        setLoading(true);
        const response = await activityAPI.getActivityFeed(page);
        setActivities(response.data.data);
        setTotalPages(response.data.totalPages);
      } catch (err) {
        setError("Failed to load activities. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, [page]);

  const renderActivityItem = (activity) => {
    switch (activity.itemType) {
      case "booking":
        return (
          <div key={activity._id} className="activity-item">
            <FaCalendarAlt className="activity-icon booking" />
            <div className="activity-details">
              <p>
                <strong>{activity.sessionType} Session</strong>
              </p>
              <p>
                {new Date(activity.appointmentDate).toLocaleDateString()} -{" "}
                {activity.status}
              </p>
            </div>
          </div>
        );
      case "payment":
        return (
          <div key={activity._id} className="activity-item">
            <FaReceipt className="activity-icon payment" />
            <div className="activity-details">
              <p>
                <strong>Payment Received</strong>
              </p>
              <p>
                ${(activity.amount / 100).toFixed(2)} - {activity.description}
              </p>
            </div>
          </div>
        );
      case "terminal_transaction":
        return (
          <div key={activity._id} className="activity-item">
            <FaReceipt className="activity-icon terminal" />
            <div className="activity-details">
              <p>
                <strong>In-Studio Purchase</strong>
              </p>
              <p>
                ${(activity.amount / 100).toFixed(2)} - {activity.status}
              </p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <FaSpinner className="spinner" />
        <p>Loading activity...</p>
      </div>
    );
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="activity-feed">
      {activities.length > 0 ? (
        activities.map(renderActivityItem)
      ) : (
        <p>No activities found.</p>
      )}
      <div className="pagination">
        {page > 1 && (
          <button onClick={() => setPage(page - 1)}>Previous</button>
        )}
        {page < totalPages && (
          <button onClick={() => setPage(page + 1)}>Next</button>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;
